"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ReactDOM = require("react-dom");
var icons_1 = require("@uifabric/icons");
var file_type_icons_1 = require("@uifabric/file-type-icons");
var app_1 = require("./app");
var registerServiceWorker_1 = require("./registerServiceWorker");
icons_1.initializeIcons();
file_type_icons_1.initializeFileTypeIcons();
ReactDOM.render(React.createElement(app_1.default, null), document.getElementById("root"));
registerServiceWorker_1.default();
//# sourceMappingURL=index.js.map